CheckoutV2.PaymentV2.Affirm = function(checkout, $container) {
    var method = this;

    this._init = function() {
        method._render();

        // Any time we switch to paypal on the payment step, reactivate the redirect
        if(checkout.currentStepName() === 'payment') {
            method.setNextStepButtonHtml();
        }

        method._setPaymentActiveMethods(checkout.cart.totals.values.remaining);

        checkout.payment.onMethodValid();
    };

    this._render = function() {
        var $content = $($.parseHTML(Jemplate.process('includes/partials/payment/affirm.html')));
        $container.find('.payment-method-affirm-container').html($content);
        $container.find('.collapse').addClass('show');
    };

    // Sets the payment modules active methods
    this._setPaymentActiveMethods = function(amount){
        var paymentMethod = checkout.payment.models.paymentMethodFromAffirm(amount);
        checkout.payment.setActivePaymentMethods([paymentMethod]);
    };

    // Called by checkout and the method to set the next step button text
    this.setNextStepButtonHtml = function() {
        checkout.payment.setNextStepCTA('affirm');
        checkout.payment.setNextStepButtonHtml('Proceed to Affirm <i class="fa fa-arrow-right"></i>');

        // We need to set the third party payment to active as well when selected
        checkout.payment.setThirdPartyPaymentActive(true, 'affirm');
    };

    this._init();
};